import { Injectable } from '@angular/core';
import { DialogService, DialogRef, DialogResult } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ConfirmationDialogService {

  constructor(private dialogService: DialogService) { }

  open(
    title: string,
    content: string,
    okOnly: boolean = false
  ): Observable<DialogResult> {

    const actions = okOnly
      ? [
        { text: 'OK', value: true, themeColor: 'primary' }
      ]
      : [
        { text: 'Yes', value: true, themeColor: 'primary' },
        { text: 'No', value: false }
      ];

    const dialog: DialogRef = this.dialogService.open({
      title: title,
      content: content,
      actions: actions,
      width: 450,
      height: 200,
      minWidth: 250,
      cssClass: 'isg-dialog-editor isg-dialog-top'
    });

    return dialog.result.pipe(
      tap(result => {
        if (result !== undefined) {
          dialog.close();
        }
      })
    );
  }
}
